import { createFileRoute } from "@tanstack/react-router";
import { getMfaSettings } from "./-query/api";

export const Route = createFileRoute(
  "/_staff/settings/persons/_list/settings/",
)({
  loader: async () => getMfaSettings(),
});
